export const appRegistry = {
  "/app": {
    appName: "Abra Controls Directive 83",
    showFooterNavOnDesktop: true,
    user: { name: "Sign In", email: "" },
  },
  "/app/treatment": {
    appName: "Abra Controls Directive 83",
    showFooterNavOnDesktop: true,
    user: { name: "Sign In", email: "" },
  },
  // add more slugs here
};